export default "__VITE_ASSET__DYqLEFUt__"